import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const TermsOfServiceScreen = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <div className="bg-primary text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-sofia font-bold mb-4">
            {t('terms.title')}
          </h1>
          <p className="text-xl font-sofia opacity-90">
            {t('terms.subtitle')}
          </p>
          <p className="text-sm font-sofia opacity-75 mt-4">
            {t('terms.lastUpdated')}: {t('terms.updateDate')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          
          {/* Introduction */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.introduction.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed mb-4">
              {t('terms.introduction.content')}
            </p>
          </section>

          {/* Acceptance of Terms */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.acceptance.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed">
              {t('terms.acceptance.content')}
            </p>
          </section>

          {/* Booking and Reservations */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.booking.title')}
            </h2>
            
            <h3 className="text-xl font-sofia font-semibold text-text-primary mb-4">
              {t('terms.booking.reservations.title')}
            </h3>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed mb-6 space-y-2">
              {t('terms.booking.reservations.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3 className="text-xl font-sofia font-semibold text-text-primary mb-4">
              {t('terms.booking.payment.title')}
            </h3>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed mb-6 space-y-2">
              {t('terms.booking.payment.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Cancellation Policy */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.cancellation.title')}
            </h2>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed space-y-2">
              {t('terms.cancellation.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Guest Responsibilities */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.guestResponsibilities.title')}
            </h2>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed space-y-2">
              {t('terms.guestResponsibilities.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Property Rules */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.propertyRules.title')}
            </h2>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed space-y-2">
              {t('terms.propertyRules.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Liability */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.liability.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed">
              {t('terms.liability.content')}
            </p>
          </section>

          {/* Force Majeure */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.forceMajeure.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed">
              {t('terms.forceMajeure.content')}
            </p>
          </section>

          {/* Governing Law */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.governingLaw.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed">
              {t('terms.governingLaw.content')}
            </p>
          </section>

          {/* Contact */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('terms.contact.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed mb-4">
              {t('terms.contact.content')}
            </p>
            <div className="bg-background p-6 rounded-lg">
              <p className="font-sofia text-text-primary">
                <strong>Email:</strong> {t('contact.email')}
              </p>
              <p className="font-sofia text-text-primary">
                <strong>{t('contact.phone.title')}:</strong> {t('contact.phone.morocco')}
              </p>
            </div>
          </section>

        </div>

        {/* Back to Home */}
        <div className="text-center mt-12">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-accent text-white font-sofia font-medium rounded-lg hover:bg-accent/90 transition-colors duration-200"
          >
            {t('common.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceScreen;
